import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  style: {
    "display": "contents"
  },
  class: "stocklist"
};
const _hoisted_2 = {
  class: "m-t-10 table_90 p-b-20 border-r-10 text-black f-12",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_4 = {
  style: {
    "width": "470px",
    "padding-top": "15px",
    "margin-left": "10px",
    "font-size": "13px"
  }
};
const _hoisted_5 = {
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_6 = {
  style: {
    "margin-right": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_col, {
      span: 25,
      style: {
        "margin-top": "40px",
        "display": "contents",
        "margin-left": "10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.filter,
        "label-width": "130px",
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              class: "label-sku",
              label: "规格型号（SKU）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.sku,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form_requst.sku = $event),
                placeholder: "请输入规格型号（SKU）"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "物料名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form_requst.name = $event),
                placeholder: "请输入物料名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "物料编码"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.fnumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form_requst.fnumber = $event),
                placeholder: "请输入物料编码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "批号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.bn,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form_requst.bn = $event),
                placeholder: "请输入批号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "仓库名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.form_requst.FSTOCKID,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form_requst.FSTOCKID = $event),
                placeholder: "请选择",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stocklist, (it, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: it.value,
                    value: it.key
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "子仓库"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.stock_sub,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form_requst.stock_sub = $event),
                placeholder: "请输入子仓库"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "组织"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: $data.form_requst.org,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form_requst.org = $event),
                placeholder: "请选择",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orglist, (it, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: it.value,
                    value: it.key
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4,
            offset: 2,
            style: {
              "display": "flex",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.search
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("搜索")])),
              _: 1,
              __: [7]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.reset
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("重置")])),
              _: 1,
              __: [8]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.syncData
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("同步ERP数据")])),
              _: 1,
              __: [9]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.batchExport
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("导出")])),
              _: 1,
              __: [10]
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_vxe_table, {
      border: "",
      resizable: "",
      "show-overflow": "",
      ref: "xTable",
      height: "650",
      "scroll-x": {
        enabled: false
      },
      "scroll-y": {
        enabled: false
      },
      "header-cell-style": $data.header_style,
      data: $data.tableData
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        field: "fnumber",
        title: "物料编码",
        width: "110",
        "header-align": "center",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "sku",
        title: "规格型号（SKU）",
        width: "170",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "name",
        title: "物料名称",
        width: "140",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "stock",
        title: "仓库名称",
        width: "120",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "stock_sub",
        title: "子仓库",
        width: "180",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "bn",
        title: "批号",
        width: "110",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "inventory_num",
        title: "库存量",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "available_num",
        title: "可用量",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "factory_price",
        title: "出厂价（¥）",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_column, {
        field: "inventory_price",
        title: "库存金额（¥）",
        "header-align": "center",
        align: "right"
      }), _createVNode(_component_vxe_colgroup, {
        title: "平均出厂价（¥）",
        "header-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "avg_factory_price_stock_sub",
          title: "本子仓库",
          "header-align": "center",
          align: "right"
        }), _createVNode(_component_vxe_column, {
          field: "avg_factory_price_stock",
          title: "本仓库",
          "header-align": "center",
          align: "right"
        }), _createVNode(_component_vxe_column, {
          field: "avg_factory_price_org",
          title: "本组织",
          "header-align": "center",
          align: "right"
        }), _createVNode(_component_vxe_column, {
          field: "avg_factory_price_all",
          title: "所有组织",
          "header-align": "center",
          align: "right"
        })]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "org_name",
        title: "组织",
        width: "180",
        "header-align": "center",
        align: "left"
      })]),
      _: 1
    }, 8, ["header-cell-style", "data"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("b", null, [_createElementVNode("span", _hoisted_5, " 库存量:" + _toDisplayString($data.dataCount.total_inventory_num), 1), _createElementVNode("span", _hoisted_6, " 可用量:" + _toDisplayString($data.dataCount.total_available_num), 1), _createTextVNode(" 库存金额(¥):" + _toDisplayString($data.dataCount.total_inventory_price), 1)])]), _createVNode(_component_el_pagination, {
      "current-page": $data.form_requst.page,
      "page-sizes": [20, 60, 100],
      "page-size": $data.form_requst.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: $data.count,
      class: "m-t-10 m-b-20 table_90",
      onSizeChange: $options.handleSizeChange,
      onCurrentChange: $options.handleCurrentChange
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])])]),
    _: 1
  });
}